import strFunc from "@/lib/lyg/string";

function ListArea(props: any) {
  let myProps = {
    study_use_arr: [],
    Style: {},
    set_page_sort: (inData: any) => { },
    set_select_study_use: (inData: any) => { },
    ...props
  };
  let Style = myProps.Style;

  const get_study_per_data = (inData: any) => {
    let opt_obj = {
      study_arr: [],
      use_det_arr: [],
      ...inData
    };
    let study_arr = opt_obj.study_arr;
    let use_det_arr = opt_obj.use_det_arr;
    let study_per_data: any = {
      per_arr: [],
      per_total: 0,
      success_cnt: 0,
      total_cnt: study_arr.length,
      per_success: 0,
      per: 0,
    };

    for (let s_i = 0; s_i < study_arr.length; s_i++) {
      let study_item = study_arr[s_i];
      let detail_item = null;
      for (let d_i = 0; d_i < use_det_arr.length; d_i++) {
        let tmp_detail_item = use_det_arr[d_i];
        if (study_item.a_book_seq == tmp_detail_item.a_book_seq
          && study_item.a_seq == tmp_detail_item.a_book_list_seq
        ) {
          detail_item = tmp_detail_item;
        }
      }

      if (detail_item != null) {
        let d_per = 0;
        if (detail_item.a_is_success == "1") {
          d_per = 100;
        } else {
          d_per = 0;
          if (detail_item.a_amount && detail_item.a_success_amount) {
            let d_amount = parseInt(strFunc.uncomma(detail_item.a_amount));
            let d_success_amount = parseInt(strFunc.uncomma(detail_item.a_success_amount));
            if (d_amount > 0) {
              d_per = (d_success_amount/d_amount) * 100;
            }
          }
          if (d_per > 100) {
            d_per = 100;
          }
        }
        study_per_data.per_arr.push(d_per);
        study_per_data.per_total += d_per;
        if (d_per >= 100) {
          study_per_data.success_cnt++;
        }
      }
    }

    //평균
    if (study_per_data.total_cnt > 0) {
      if (study_per_data.per_total > 0) {
        study_per_data.per = study_per_data.per_total / study_per_data.total_cnt;
        study_per_data.per = study_per_data.per.toFixed(1);
        study_per_data.per_success=study_per_data.per;
      }
    }

    return study_per_data;
  };

  const get_study_use_tags = () => {
    let study_use_tags = myProps.study_use_arr.map((item: any, idx: number) => {
      let study_title = "";
      if (item.textbook_title) {
        study_title = item.textbook_title;
      }
      let row_study_arr: any = [];
      if (item.study_arr) {
        row_study_arr = item.study_arr;
      }
      let row_use_det_arr: any = [];
      if (item.use_det_arr) {
        row_use_det_arr = item.use_det_arr;
      }
      let study_per_data = get_study_per_data({
        study_arr: row_study_arr,
        use_det_arr: row_use_det_arr
      });

      return (
        <tr key={idx}
          className={Style.go_detail_tr}
          onClick={() => {
            myProps.set_page_sort("detail");
            myProps.set_select_study_use(item);
          }}>
          <td>{study_title}</td>
          <td>{item.a_re_start_date}</td>
          <td>
            {study_per_data.per_success}%
            ({study_per_data.success_cnt}/{study_per_data.total_cnt})
          </td>
        </tr>
      );
    });

    if (strFunc.is_empty(study_use_tags)) {
      return (
        <tr>
          <td colSpan={4}>내용이 없습니다.</td>
        </tr>
      );
    }

    return study_use_tags;
  };
  const get_study_use_table = () => {
    let study_use_table =
      (
        <table>
          <thead>
            <tr>
              <th>제목</th>
              <th>시작일</th>
              <th>학습률</th>
            </tr>
          </thead>
          <tbody>
            {get_study_use_tags()}
          </tbody>
        </table>
      );
    return study_use_table;
  };
  return (
    <div className={Style.study_use_list_area}>
      {get_study_use_table()}
    </div>
  );
};
export default ListArea;